import { api } from '@/services';
import type {
  FechamentoCompetenciaPayload,
  StatusFechamentoResponse,
  FecharAbrirCompetenciaResponse,
} from './types';

export async function fetchStatusFechamento(
  payload: FechamentoCompetenciaPayload
): Promise<StatusFechamentoResponse> {
  return api.post<StatusFechamentoResponse, FechamentoCompetenciaPayload>(
    'TurboPro/SimplesNacional/StatusFechamento',
    payload
  );
}

export async function fecharCompetencia(
  payload: FechamentoCompetenciaPayload
): Promise<FecharAbrirCompetenciaResponse> {
  return api.post<FecharAbrirCompetenciaResponse, FechamentoCompetenciaPayload>(
    'TurboPro/SimplesNacional/FecharCompetencia',
    payload
  );
}

export async function abrirCompetencia(
  payload: FechamentoCompetenciaPayload
): Promise<FecharAbrirCompetenciaResponse> {
  return api.post<FecharAbrirCompetenciaResponse, FechamentoCompetenciaPayload>(
    'TurboPro/SimplesNacional/AbrirCompetencia',
    payload
  );
}
